import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { Strings } from "../../resources/i18n/i18n";
import Utility from "../../utils/Utility";
import TextFieldComponent from "../CustomUIComponents/TextFieldComponent/TextFieldComponent";
import { FREQUENCIES, WEEKLY_SIX } from "../LoanDetails/Constants";
import moment from "moment";
import { getEmiDurationAction, getFrequencyConfigurationAction, getPossibleCollectionCycleAction, getTermsAndrateAction } from "../AnalystApproval/AnalystApprovalAction";
import { OPERATION_STATUS } from "../../config/axios.init";
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";
import { LOAN_CREATION, LOANS_WITH_TABLE_DATA } from "./CreateLoanConstants";
const { Row, Col, Button } = require("react-bootstrap");

class CalculateEMIModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      frequencyList: [],
      termsArray: [],
      possibleCollectionDays: [],
      calculatedEMIData: {},
      calculationData: {
        EMIAmount: props.calculateEMIData.EMIAmount,
        frequency: "",
        term: "",
        collectionDays: "",
      },
    }
  }
  getFrequencyList = (request) => {
    this.setState({
      showLoadingModal: true,
    });
    getFrequencyConfigurationAction(request, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState(prevState => ({
          showLoadingModal: false,
          errorMessage: "",
          frequencyList: response.data.data.frqs,
        }));
      } else {
        this.setState({
          errorMessage: response.error.message,
          showLoadingModal: false,
        });
      }
    });
  };
  getTermsAndrate = (request) => {
    this.setState({
      showLoadingModal: true,
    });
    getTermsAndrateAction(request, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState(
          {
            showLoadingModal: false,
            errorMessage: "",
          },
          () => {
            this.setTermsArray(response.data.data.td)
          }
        );
      } else {
        this.setState({
          errorMessage: response.error.message,
          showLoadingModal: false,
        });
      }
    });
  };
  calculateEMICall = () => {
    let requestData = {
      minimartId: this.props.minimart.minimartDetails.id,
      loanType: this.props.loanType,
      term: this.state.calculationData["term"],
      amount: this.state.calculationData["EMIAmount"],
      frequency: this.state.calculationData["frequency"],
      collectionDays: this.state.calculationData["collectionDays"],
    }
    this.setState({
      showLoadingModal: true
    })
    getEmiDurationAction(requestData, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState({
          showLoadingModal: false,
          calculatedEMIData: response.data.data,
          errorMessage: "",
        });
      } else {
        this.setState({
          showLoadingModal: false,
          errorMessage: response.error.message,
        })
      }
    })
  }
  renderModalButtons = () => {
    return (
      <Row className='modalButton'>
        <Col md={12}>
          <Button
            className={
              " primaryModalButton buttonMinWidth marginCancelButton buttonBorder"
            }
            onClick={this.props.toggleModal}
          >
            {Strings("Cancel")}
          </Button>
        </Col>
      </Row>
    );
  };
  renderTextField = (key, disabled) => {
    return (
      <TextFieldComponent
        type="number"
        handleChange={this.onChangeInput}
        name={key}
        value={this.state.calculationData[key]}
        placeholderTop={key === "EMIAmount" ? Strings('Amount') + " ($)" : Strings(key)}
        placeholder={key === "EMIAmount" ? Strings("Amount") : Strings(key)}
        placeholderTopClass='inputPlaceholderTop'
        disabled={disabled || this.props.isHistory}
        title={disabled ? Strings("notAllowedForThisLoanType") : Strings(key)}
      />
    )
  }
  onChangeInput = (event) => {
    let value = event.target.value;
    let key = event.target.name;
    let calculatedEMIData;
    let calculationData = { ...this.state.calculationData };
    if (key === "EMIAmount") {
      calculationData = {
        [key]: value,
        frequency: "",
        term: "",
        collectionDays: "",
      }
    } else if (key === "frequency") {
      calculationData = {
        ...calculationData,
        [key]: value,
        term: "",
        collectionDays: value === FREQUENCIES.WEEKLY_SIX ? WEEKLY_SIX.toString() : "",
      }
      calculatedEMIData = {};
      this.assignTermsAndrateAction(calculationData);
    } else {
      calculationData = {
        ...calculationData, [key]: value,
      }
      calculatedEMIData = {};
    }
    this.setState(
      {
        errorMessage: "",
        calculationData,
        calculatedEMIData,
      },
      () => {
        if (key === 'frequency' && this.state.calculationData.frequency !== "") {
          this.state.calculationData.frequency !== FREQUENCIES.WEEKLY_SIX
            && this.getPossibleCollectionCycles({ fr: this.state.calculationData.frequency })
        }
      }
    );
  };
  checkInputs = () => {
    let valid = true;

    if (
      !this.state.calculationData.EMIAmount ||
      !this.state.calculationData.term ||
      !this.state.calculationData.frequency ||
      (!this.state.calculationData.collectionDays) ||
      (this.state.calculationData?.term === Strings("termsUnavailable")) ||
      this.state.termsArray[0].toString() === "-1"
    ) {
      valid = false;
    }

    return valid;
  };

  calculateEMI = () => {
    let valid = this.checkInputs();
    if (!valid) {
      this.setState({
        errorMessage: Strings("pleaseSelectCorrectCalculationData")
      })
    } else {
      this.calculateEMICall()
    }

  }
  getPossibleCollectionCycles = (req) => {
    this.setState({ showLoadingModal: true });
    let request = req;
    request["mid"] = this.props.minimart.minimartDetails.id;
    if (request.fr !== FREQUENCIES.WEEKLY_THRICE && !this.props.isHistory) {
      request["frs"] = LOAN_CREATION;
    }
    getPossibleCollectionCycleAction(request, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        let possibleCollectionDays = Utility.convertCollectionDaysToSpanishForDropdown(response.data.data.possibleCollectionDays)
        this.setState({
          showLoadingModal: false,
          possibleCollectionDays,
          currentCollectionCycle: response.data.data.minimartCollectionCycle,
          errorMessage: "",
        });
      } else {
        this.setState({
          showLoadingModal: false,
          errorMessage: response.error.message,
        });
      }
    });
  }
  renderSelectField = (key, dropdownList, disabled = false) => {
    return (
      <TextFieldComponent
        type='select'
        handleChange={this.onChangeInput}
        placeholder={Strings(key)}
        value={this.state.calculationData[key]}
        placeholderTop={Strings(key)}
        placeholderTopClass='inputPlaceholderTop inputPlaceholderTopBottomMargin'
        name={key}
        disabled={disabled}
        title={disabled ? Strings("notAllowedForSelectedFrequency") : Strings(key)}
        onFocus={(event) => this.handleOnSelectClick(event)}
      >
        <option default value=''>
          {Strings(key)}
        </option>
        {dropdownList.map((option) => {
          return (
            <option
              key={option.value || option}
              value={option.value || option}
            >
              {Strings(option.label) || Strings(option)}
            </option>
          );
        })}
      </TextFieldComponent>
    )
  }
  renderCalculatedEMI = () => {
    let amountCharged = this.state.calculatedEMIData?.emi
      ? (this.state.calculatedEMIData.totalInterest ?? (this.state.calculatedEMIData.emi * this.state.calculationData.term) - this.state.calculationData.EMIAmount)
      : "";
    return <Col md={12} className='noPadding'>
      <Row>
        <Col md={12} className='ps-0 '>
          <div className='subHeadingText ps-0'>
            {Strings("EMICollection")}<span>
            </span>
          </div>
        </Col>
        <Col md={12} className='ps-0'>
          <div className='subText'>
            {Strings("amountChargedForTerm").replace("$", "$ " + Utility.getCurrencyRepresentationOfAmount(amountCharged))}
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={6} className='ps-0'>
          <div className='subHeadingText pt-2'>
            {Strings("FromDate")}
          </div>
        </Col>
        <Col md={6}>
          <div className='subHeadingText pt-2'>
            {Strings("ToDate")}<span>
            </span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={6} className='ps-0'>
          <div className='subText' title={Strings("FromDate")}>
            {this.state.calculatedEMIData?.period ?
              moment.utc(
                this.state.calculatedEMIData.period.start
              ).format("dddd, ll") : Strings("NA")}
          </div>
        </Col>
        <Col md={6} className=''>
          <div className='subText' title={Strings("ToDate")}>
            {this.state.calculatedEMIData?.period
              ? moment.utc(this.state.calculatedEMIData.period.end).format("dddd, ll")
              : Strings("NA")}
          </div>
        </Col>
        <Col md={6} className='ps-0'>
          <div className='subHeadingText pt-2'>
            {Strings("emiAmount")}
          </div>
        </Col>
        <Col md={6}>
          <div className='subHeadingText pt-2'>
            {Strings("noOfEmi")}<span>
            </span>
          </div>
        </Col>
        <Col md={6} className='ps-0'>
          <div className='subText' title={Strings("emiAmount")}>
            {this.state.calculatedEMIData?.emi
              ? "$ " +
              Utility.getCurrencyRepresentationOfAmount(
                this.state.calculatedEMIData.emi
              )
              : Strings("NA")}
          </div>
        </Col>
        <Col md={6} className=''>
          <div className='subText' title={Strings("noOfEmi")}>
            {this.state.calculationData?.term
              ? this.state.calculationData.term
              : Strings("NA")}
          </div>
        </Col>
        <Col md={12} className='ps-0 '>
          <div className='subHeadingText ps-0 pt-2'>
            {Strings("collectionDays")}<span>
            </span>
          </div>
        </Col>
        <Col md={12} className='p-0'>
          <div className='subText' title={Strings("collectionDays")}>
            {this.state.calculatedEMIData?.daysOfCollection
              ? this.state.calculatedEMIData.daysOfCollection
              : Strings("NA")}
          </div>
        </Col>
      </Row>
    </Col>
  }
  handleOnSelectClick = (event) => {
    let key = event.target.name || event.currentTarget.name;
    let tagName = event.target.tagName || event.currentTarget.tagName;

    if (key === "frequency" && (tagName === "SELECT" || tagName === "OPTION")) {
      const request = {
        loanType: this.props.loanType,
        amount: this.state.calculationData["EMIAmount"],
        level: this.props.minimart.creditLimit.eligibility,
        minimartId: this.props.minimart.minimartDetails.id,
      }
      this.getFrequencyList(request);
    }
  }


  assignTermsAndrateAction = (calculationData) => {
    const requestData = {
      loanType: this.props.loanType,
      amount: calculationData["EMIAmount"],
      frequency: calculationData["frequency"]
    }
    if (requestData.frequency !== "") {
      this.getTermsAndrate(requestData);
    }
  }
  setTermsArray = (terms) => {
    let termArray = [];
    if (terms !== null) {
      termArray = terms?.map((term) => term.term)
    }
    this.setState({
      termsArray: termArray
    })
  }

  render() {
    return (
      <div className='notesModal'>
        <Modal
          open={this.state.open}
          onClose={this.closeModal}
          closeOnEsc={false}
          closeOnOverlayClick={false}
          classNames={{ modal: "customModal" }}
          showCloseIcon={false}
          center
        >
          <Row className='notesModal'>
            <LoadingModal
              showLoadingModal={this.state.showLoadingModal}
            />
            <Col md={12} className='headerModal'>
              {this.props.modalHeader}
            </Col>
            <Col md={12} className='modalContent pt-4 ps-4 pe-4'>
              {this.state.errorMessage && (
                <Row
                  style={{ textAlign: "center" }}
                  className='errors ps-0'
                >
                  {this.state.errorMessage}
                </Row>
              )}
              <div>
                <div className="subHeadingText">
                  {Strings(this.props.loanType)}
                </div>
                <hr className="opacity-100 pb-3 mt-2" />
                {this.props.currentCollectionCycle && (
                  <div className="warningText mb-4">
                    {`${Strings("currentCollectionCycle")} : ${Utility.convertCollectionDaysToSpanish(
                      this.props.currentCollectionCycle.split(",")
                    )}`}
                  </div>
                )}
                <Row className="mt-2">
                  <Col md={6} className="ps-0 pb-2">
                    {this.renderTextField("EMIAmount", LOANS_WITH_TABLE_DATA.includes(this.props.loanType))}
                  </Col>

                  <Col md={6} className="pb-2">
                    {this.renderSelectField(
                      "frequency",
                      this.state.frequencyList,
                      false
                    )}
                  </Col>

                  <Col md={6} className="pt-4 ps-0">
                    {this.renderSelectField(
                      "term",
                      this.state.termsArray,
                      false
                    )}
                  </Col>
                  <Col md={6} className=" pt-4">
                    {true &&
                      this.renderSelectField("collectionDays", this.state.possibleCollectionDays, false)}
                  </Col>
                </Row>
                <Row className="mt-2 justify-content-end">
                  <div className="ps-0 pt-2 pb-3 w-auto">
                    {(
                      <Button
                        className="buttonBackground m-0"
                        onClick={this.calculateEMI}
                      >
                        {Strings("calculateEmi")}
                      </Button>
                    )}
                  </div>
                </Row>
                <Row>
                  <hr className="opacity-100" />
                  {this.renderCalculatedEMI()}

                </Row>
              </div>

              {this.renderModalButtons()}
            </Col>
          </Row>
        </Modal>
      </div>
    )
  }
}
export default CalculateEMIModal;